import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // withCredentials is intentionally OFF. The backend ingress/Cloudflare
  // layer returns "access-control-allow-origin: *" which is INVALID in
  // combination with "access-control-allow-credentials: true" per the CORS
  // spec — Safari on iOS strictly enforces this and blocks the response
  // with a "Network Error". The app uses JWT-in-localStorage auth (sent
  // via the Authorization header below), so cookies aren't needed.
  withCredentials: false,
  // 30s timeout so mobile users on flaky connections see a real error
  // instead of a hung request that looks like the app is broken
  timeout: 30000,
});

// Add JWT token to requests if available.
// JWT-in-localStorage is a deliberate trade-off — see /app/CODE_REVIEW_NOTES.md §3.
// httpOnly cookies would be more XSS-resistant but break mobile login because
// the platform ingress emits an invalid CORS combo (`*` + credentials).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('salonflow_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('salonflow_token');
      const path = window.location.pathname;
      const publicPaths = ['/', '/signup', '/login', '/book', '/salon', '/employee', '/clock', '/t/', '/platform', '/reset-password', '/events/intake', '/events/inquire'];
      const isPublic = publicPaths.some(p => path === p || path.startsWith(p + '/') || path.startsWith(p));
      if (!isPublic && !window.location.hash.includes('session_id')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API, BACKEND_URL };
